var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20px",
  height: "19px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "19 8.5 3.03025 8.5 10.07615 1.4541 9.0156 0.39355 0.1592 9.25 9.0156 18.10645 10.07615 17.0459 3.03025 10 19 10"
})));
export { SvgArrowBack as ReactComponent };